(function () {
  'use strict';

  if (window.__oatWishlistDrawerInit) return;
  window.__oatWishlistDrawerInit = true;

  const DRAWER_ID = 'oat-account-wishlist-drawer';
  const SUPPORT_MESSAGE = 'Hmm...that is weird. Something went wrong, but admin@oatmeal.in is working on it';
  const EMPTY_MESSAGE = 'Your wishlist is empty.';
  const LOADING_MESSAGE = 'Warming up your wishlist...';
  const productCache = new Map();
  const productPageCache = new Map();

  let previousScrollY = 0;
  let requestToken = 0;

  function getDrawer() {
    return document.getElementById(DRAWER_ID);
  }

  function getRefs() {
    const drawer = getDrawer();
    if (!drawer) return null;

    return {
      drawer,
      closeButton: drawer.querySelector('[data-oat-account-wishlist-close]'),
      title: drawer.querySelector('[data-oat-account-wishlist-title]'),
      list: drawer.querySelector('[data-oat-account-wishlist-list]'),
      status: drawer.querySelector('[data-oat-account-wishlist-status]'),
      subline: drawer.querySelector('[data-oat-account-wishlist-subline]'),
    };
  }

  function getStore() {
    return window.OatmealWishlistStore || null;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }

  function toText(value) {
    return String(value == null ? '' : value).trim();
  }

  function toId(value) {
    const raw = toText(value);
    return raw || '';
  }

  function normalizeColorValue(value) {
    const raw = toText(value);
    if (!raw) return '';
    return raw.split(' - ')[0].trim();
  }

  function isLoggedIn() {
    return window.OATMEAL_IS_LOGGED_IN === true;
  }

  function lockBody() {
    previousScrollY = window.scrollY;
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${previousScrollY}px`;
  }

  function unlockBody() {
    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo({ top: previousScrollY, behavior: 'instant' });
  }

  function waitForAnimationEnd(element, fallbackMs) {
    return new Promise((resolve) => {
      let settled = false;

      const finish = () => {
        if (settled) return;
        settled = true;
        element.removeEventListener('animationend', finish);
        window.clearTimeout(timer);
        resolve();
      };

      const timer = window.setTimeout(finish, fallbackMs);
      element.addEventListener('animationend', finish, { once: true });
    });
  }

  function setTitleCount(count) {
    const refs = getRefs();
    if (!refs?.title) return;
    refs.title.textContent = `YOUR WISHLIST (${Math.max(0, Number(count) || 0)})`;
  }

  function setSubline(text) {
    const refs = getRefs();
    if (!refs?.subline) return;
    refs.subline.textContent = text || '';
  }

  function setStatus(text) {
    const refs = getRefs();
    if (!refs) return;

    refs.status.textContent = text || '';
    refs.status.hidden = !text;
    refs.list.hidden = true;
    refs.list.innerHTML = '';
  }

  function clearStatus() {
    const refs = getRefs();
    if (!refs) return;

    refs.status.textContent = '';
    refs.status.hidden = true;
    refs.list.hidden = false;
  }

  function setLoading() {
    setSubline('');
    setStatus(LOADING_MESSAGE);
  }

  async function fetchProductJsonByHandle(handle) {
    const productHandle = toText(handle);
    if (!productHandle) throw new Error('Missing product handle');

    if (productCache.has(productHandle)) {
      return productCache.get(productHandle);
    }

    const response = await fetch(`/products/${encodeURIComponent(productHandle)}.js`, {
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error(`Product fetch failed for ${productHandle}`);
    }

    const product = await response.json();
    productCache.set(productHandle, product);
    return product;
  }

  async function fetchProductPageDataByHandle(handle) {
    const productHandle = toText(handle);
    if (!productHandle) throw new Error('Missing product handle');

    if (productPageCache.has(productHandle)) {
      return productPageCache.get(productHandle);
    }

    const response = await fetch(`/products/${encodeURIComponent(productHandle)}`, {
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error(`Product page fetch failed for ${productHandle}`);
    }

    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const ratingSource = doc.querySelector('[data-oatmeal-pdp-rating]');
    const ratingValue = Number(ratingSource?.getAttribute('data-oatmeal-pdp-rating') || '');
    const ratingCount = Number(ratingSource?.getAttribute('data-oatmeal-pdp-rating-count') || '');

    const swatches = [];
    const seen = new Set();
    const swatchFieldsets = Array.from(doc.querySelectorAll('.variant-option--swatches'));

    for (const fieldset of swatchFieldsets) {
      const legendText = toText(fieldset.querySelector('.variant-option__legend-left')?.textContent).toLowerCase();
      if (!(legendText.includes('color') || legendText.includes('colour'))) continue;

      const labels = Array.from(fieldset.querySelectorAll('.variant-option__button-label--has-swatch'));
      for (const label of labels) {
        const input = label.querySelector('input[type="radio"]');
        const swatch = label.querySelector('.swatch');
        const value = toText(input?.value);
        if (!value || seen.has(value.toLowerCase())) continue;
        seen.add(value.toLowerCase());

        swatches.push({
          value,
          style: swatch?.getAttribute('style') || '',
          available: input?.getAttribute('data-option-available') !== 'false',
        });
      }

      if (swatches.length) break;
    }

    const data = {
      rating: Number.isFinite(ratingValue) ? ratingValue : null,
      ratingCount: Number.isFinite(ratingCount) ? ratingCount : null,
      swatches,
    };

    productPageCache.set(productHandle, data);
    return data;
  }

  function findOptionIndex(options, re) {
    if (!Array.isArray(options)) return -1;
    return options.findIndex((option) => re.test(String(option)));
  }

  function getColorValueForItem(product, item) {
    const options = Array.isArray(product?.options) ? product.options : [];
    const colorIdx = findOptionIndex(options, /colou?r/i);
    const resolvedColorIdx = colorIdx !== -1 ? colorIdx : 0;
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    const targetVariantId = toId(item?.variantId);

    const variant =
      variants.find((entry) => toId(entry?.id) === targetVariantId) ||
      variants.find((entry) => entry?.available) ||
      variants[0];

    const variantColor = toText(variant?.options?.[resolvedColorIdx]);
    if (variantColor) return variantColor;

    return normalizeColorValue(item?.color);
  }

  function buildSizeChoicesFromProduct(product, colorValue) {
    const optionNames = Array.isArray(product?.options) ? product.options : [];
    const colorIdx = findOptionIndex(optionNames, /colou?r/i);
    const sizeIdx = findOptionIndex(optionNames, /size/i);

    const resolvedColorIdx = colorIdx !== -1 ? colorIdx : 0;
    const resolvedSizeIdx = sizeIdx !== -1 ? sizeIdx : 1;
    const targetColor = normalizeColorValue(colorValue);
    const variants = Array.isArray(product?.variants) ? product.variants : [];

    let filtered = variants.filter((variant) => {
      if (!variant) return false;
      if (!targetColor) return true;
      return normalizeColorValue(variant?.options?.[resolvedColorIdx]) === targetColor;
    });

    if (!filtered.length) {
      filtered = variants.filter(Boolean);
    }

    const seen = new Set();
    const choices = [];

    for (const variant of filtered) {
      const size = toText(variant?.options?.[resolvedSizeIdx]);
      if (!size || seen.has(size)) continue;
      seen.add(size);
      choices.push({
        size,
        variantId: toId(variant?.id),
        available: variant?.available === true,
      });
    }

    return {
      ok: choices.length > 0,
      choices,
    };
  }

  function getVariantForItem(product, item, colorValue) {
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    const itemVariantId = toId(item?.variantId);
    const color = normalizeColorValue(colorValue);

    return (
      variants.find((variant) => toId(variant?.id) === itemVariantId) ||
      variants.find((variant) => normalizeColorValue(variant?.options?.[0]) === color && variant?.available) ||
      variants.find((variant) => normalizeColorValue(variant?.options?.[0]) === color) ||
      variants.find((variant) => variant?.available) ||
      variants[0] ||
      null
    );
  }

  function getVariantImageSrc(variant, product) {
    const fromVariant =
      toText(variant?.featured_image?.src) ||
      toText(variant?.featured_media?.preview_image?.src) ||
      toText(variant?.image?.src);

    if (fromVariant) return fromVariant;
    return toText(product?.featured_image);
  }

  function formatMoney(amount, currency) {
    const numeric = Number(amount);
    if (!Number.isFinite(numeric)) return '';

    const money = numeric / 100;
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: currency || 'INR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(money);
    } catch (_) {
      return `₹ ${money.toFixed(2)}`;
    }
  }

  function getColorFallback(colorName) {
    const colors = {
      'Plum Perfect': '#8B4789',
      'Lily Pad': '#90B494',
      'Sun Dried Tomato': '#C85A54',
      Black: '#000000',
      'Dress Blue': '#2C3E50',
      White: '#F5F5EA',
    };
    return colors[toText(colorName)] || '#CCCCCC';
  }

  function buildColorSwatches(product, itemColor, pageData) {
    const targetColor = normalizeColorValue(itemColor);
    const pageSwatches = Array.isArray(pageData?.swatches) ? pageData.swatches : [];
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    const availabilityByColor = new Map();

    variants.forEach((variant) => {
      const color = normalizeColorValue(variant?.options?.[0]);
      if (!color) return;
      const key = color.toLowerCase();
      availabilityByColor.set(key, availabilityByColor.get(key) === true || variant?.available === true);
    });

    if (pageSwatches.length) {
      return pageSwatches.map((swatch) => ({
        value: swatch.value,
        style: swatch.style || `background-color:${getColorFallback(swatch.value)};`,
        available:
          availabilityByColor.has(normalizeColorValue(swatch.value).toLowerCase())
            ? availabilityByColor.get(normalizeColorValue(swatch.value).toLowerCase()) === true
            : swatch.available !== false,
        selected: normalizeColorValue(swatch.value).toLowerCase() === targetColor.toLowerCase(),
      }));
    }

    const seen = new Set();
    const fallback = [];

    for (const variant of variants) {
      const value = toText(variant?.options?.[0]);
      if (!value || seen.has(value.toLowerCase())) continue;
      seen.add(value.toLowerCase());
      fallback.push({
        value,
        style: `background-color:${getColorFallback(value)};`,
        available: variant?.available === true,
        selected: normalizeColorValue(value).toLowerCase() === targetColor.toLowerCase(),
      });
    }

    if (!fallback.length && targetColor) {
      fallback.push({
        value: targetColor,
        style: `background-color:${getColorFallback(targetColor)};`,
        available: true,
        selected: true,
      });
    }

    return fallback;
  }

  async function addVariantToCart(variantId, quantity) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: Number(variantId),
        quantity: Math.max(1, Number(quantity) || 1),
        properties: {
          '_Oatmeal Sale Type': 'Non - VTON',
        },
      }),
    });

    const json = await response.json().catch(() => ({}));
    if (!response.ok || json?.status === 422) {
      throw new Error(json?.description || json?.message || 'Could not add this item to your bowl');
    }

    return json;
  }

  function normalizeAvailabilityMessage(message) {
    if (typeof window.OatmealNormalizeAvailabilityMessage === 'function') {
      return window.OatmealNormalizeAvailabilityMessage(message);
    }

    const raw = String(message || '').trim();
    const lower = raw.toLowerCase();
    if (
      lower.includes('sold out') ||
      lower.includes('out of stock') ||
      lower.includes('unavailable') ||
      lower.includes('inventory') ||
      lower.includes('available quantity') ||
      lower.includes('maximum')
    ) {
      return 'This size or colour is not available right now.';
    }

    return raw || 'Could not add to bowl';
  }

  async function fetchCartCount() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) return null;

    const cart = await response.json().catch(() => null);
    return Number.isFinite(Number(cart?.item_count)) ? Number(cart.item_count) : null;
  }

  function syncHeaderCartCount(count) {
    if (!Number.isFinite(count)) return;

    const drawer = document.getElementById('header-cart-drawer');
    if (drawer) {
      drawer.dataset.cartItemCount = String(count);
    }

    document.querySelectorAll('.flo-cart-icon-bubble, [data-testid="cart-bubble"]').forEach((el) => {
      el.textContent = String(count);
      el.classList.toggle('hidden', count === 0);
    });

    document.querySelectorAll('.cart-bubble').forEach((bubble) => {
      bubble.classList.toggle('visually-hidden', count === 0);
    });
  }

  function getIcon(name) {
    const source = document.querySelector(`[data-oat-account-wishlist-icon="${name}"]`);
    return source ? source.innerHTML : '';
  }

  function getBowlIcon() {
    return getIcon('add-to-bowl');
  }

  function getDeleteIcon() {
    return getIcon('delete');
  }

  function showToast(message) {
    const refs = getRefs();
    if (!refs?.drawer || typeof window.OatmealShowToast !== 'function') return;
    window.OatmealShowToast(message, refs.drawer);
  }

  function normalizeWishlistItems(items, store) {
    const seen = new Set();
    const out = [];

    for (const raw of items || []) {
      const handle = toText(raw?.handle) || toText(store?.parseHandleFromUrl?.(raw?.productUrl || ''));
      const color = toText(raw?.color);
      const productId = toId(raw?.productId || raw?.product_id);
      const variantId = toId(raw?.variantId || raw?.variant_id);
      const productUrl = toText(raw?.productUrl || raw?.product_url) || (handle ? `/products/${handle}` : '');

      if (!handle) continue;

      const normalizedColor = normalizeColorValue(color).toLowerCase();
      const key = [handle.toLowerCase(), normalizedColor || color.toLowerCase() || productId || variantId].join('|||');
      if (seen.has(key)) continue;
      seen.add(key);

      out.push({
        handle,
        color,
        productId,
        variantId,
        productUrl,
      });
    }

    return out;
  }

  async function buildRenderableItem(item) {
    const product = await fetchProductJsonByHandle(item.handle);
    const pageData = await fetchProductPageDataByHandle(item.handle).catch(() => ({
      rating: null,
      ratingCount: null,
      swatches: [],
    }));
    const color = getColorValueForItem(product, item);
    const sizeInfo = buildSizeChoicesFromProduct(product, color);
    const variant = getVariantForItem(product, item, color);
    const price = formatMoney(variant?.price ?? product?.price, variant?.currency || product?.currency || 'INR');
    const swatches = buildColorSwatches(product, color, pageData);

    return {
      handle: item.handle,
      savedColor: item.color,
      color,
      productId: item.productId,
      variantId: toId(variant?.id || item.variantId),
      wishlistVariantId: item.variantId,
      productUrl: item.productUrl || `/products/${item.handle}`,
      imageSrc: getVariantImageSrc(variant, product),
      title: toText(product?.title) || 'Wishlist item',
      price,
      rating: Number.isFinite(Number(pageData?.rating)) ? Number(pageData.rating).toFixed(1) : '',
      swatches,
      sizeInfo,
    };
  }

  function buildRowMarkup(item, icons) {
    const sizeOptions = item.sizeInfo.ok
      ? item.sizeInfo.choices
          .map((choice) => `<option value="${escapeHtml(choice.variantId)}" ${choice.available ? '' : 'disabled'}>${escapeHtml(choice.size)}</option>`)
          .join('')
      : '';

    const swatchMarkup = (item.swatches || [])
      .map((swatch) => {
        const selectedClass = swatch.selected ? ' is-selected' : '';
        const disabledClass = swatch.available === false ? ' is-disabled' : '';
        return `
          <button
            class="oat-wl-swatch${selectedClass}${disabledClass}"
            type="button"
            data-oat-wl-swatch
            data-color="${escapeHtml(swatch.value)}"
            style="${escapeHtml(swatch.style)}"
            aria-label="${escapeHtml(swatch.value)}"
            aria-pressed="${swatch.selected ? 'true' : 'false'}"
            title="${escapeHtml(swatch.value)}"
            ${swatch.available === false ? 'disabled' : ''}
          ></button>
        `;
      })
      .join('');

    const imageMarkup = item.imageSrc ? `<img src="${escapeHtml(item.imageSrc)}" alt="${escapeHtml(item.title)}" loading="lazy">` : '';

    return `
      <div
        class="oat-wl-item"
        data-handle="${escapeHtml(item.handle)}"
        data-color="${escapeHtml(item.color)}"
        data-saved-color="${escapeHtml(item.savedColor || item.color)}"
        data-product-id="${escapeHtml(item.productId)}"
        data-variant-id="${escapeHtml(item.variantId)}"
        data-wishlist-variant-id="${escapeHtml(item.wishlistVariantId || item.variantId)}"
      >
        <a class="oat-wl-img" href="${escapeHtml(item.productUrl)}" aria-label="${escapeHtml(item.title)}">
          ${imageMarkup}
        </a>

        <div class="oat-wl-meta">
          <h3 class="oat-wl-title">
            <a href="${escapeHtml(item.productUrl)}">${escapeHtml(item.title)}</a>
          </h3>
          <div class="oat-wl-price-row">
            ${item.price ? `<p class="oat-wl-price">${escapeHtml(item.price)}</p>` : ''}
            ${item.rating ? `<p class="oat-wl-rating" aria-label="Rated ${escapeHtml(item.rating)} out of 5"><span class="oat-wl-rating__star" aria-hidden="true">★</span><span class="oat-wl-rating__value">${escapeHtml(item.rating)}</span></p>` : ''}
          </div>
          ${swatchMarkup ? `<div class="oat-wl-swatches" aria-label="Selected colour ${escapeHtml(item.color)}">${swatchMarkup}</div>` : `<p class="oat-wl-sub">${escapeHtml(item.color)}</p>`}

          <div class="oat-wl-actions">
            <select
              class="oat-wl-size"
              data-oat-wl-size
              aria-label="Select size"
              ${item.sizeInfo.ok ? '' : 'disabled'}
            >
              <option value="" selected>Select size</option>
              ${sizeOptions}
            </select>

            <button
              class="oat-wl-add"
              type="button"
              data-oat-wl-add
              data-handle="${escapeHtml(item.handle)}"
              data-color="${escapeHtml(item.color)}"
              data-saved-color="${escapeHtml(item.savedColor || item.color)}"
              data-product-id="${escapeHtml(item.productId)}"
              data-variant-id="${escapeHtml(item.variantId)}"
              data-wishlist-variant-id="${escapeHtml(item.wishlistVariantId || item.variantId)}"
              aria-label="Add to bowl"
              disabled
            >
              <span class="svg-wrapper">${icons.bowlIcon}</span>
            </button>

            <button
              class="oat-wl-remove"
              type="button"
              data-oat-wl-remove
              data-handle="${escapeHtml(item.handle)}"
              data-color="${escapeHtml(item.color)}"
              data-saved-color="${escapeHtml(item.savedColor || item.color)}"
              data-product-id="${escapeHtml(item.productId)}"
              data-variant-id="${escapeHtml(item.variantId)}"
              data-wishlist-variant-id="${escapeHtml(item.wishlistVariantId || item.variantId)}"
              aria-label="Delete from wishlist"
            >
              <span class="svg-wrapper">${icons.deleteIcon}</span>
            </button>
          </div>
        </div>
      </div>
    `;
  }

  function renderList(items) {
    const refs = getRefs();
    if (!refs) return;

    clearStatus();

    const bowlIcon = getBowlIcon();
    const deleteIcon = getDeleteIcon();

    refs.list.innerHTML = items.map((item) => buildRowMarkup(item, { bowlIcon, deleteIcon })).join('');
  }

  async function loadWishlist() {
    const refs = getRefs();
    if (!refs || !refs.drawer.open) return;

    const store = getStore();
    if (!store || !isLoggedIn()) {
      setTitleCount(0);
      setSubline('');
      setStatus(EMPTY_MESSAGE);
      return;
    }

    const normalizedItems = normalizeWishlistItems(store.list(), store);
    const currentToken = ++requestToken;

    setLoading();

    if (!normalizedItems.length) {
      if (currentToken !== requestToken) return;
      setStatus(EMPTY_MESSAGE);
      return;
    }

    try {
      const renderedItems = (
        await Promise.all(
          normalizedItems.map(async (item) => {
            try {
              return await buildRenderableItem(item);
            } catch (_) {
              return null;
            }
          })
        )
      ).filter(Boolean);

      if (currentToken !== requestToken) return;

      setTitleCount(renderedItems.length);
      setSubline('');

      if (!renderedItems.length) {
        setStatus(EMPTY_MESSAGE);
        return;
      }

      renderList(renderedItems);
    } catch (error) {
      console.warn('[Oatmeal Wishlist Drawer] Could not load wishlist', error);
      if (currentToken !== requestToken) return;
      setTitleCount(0);
      setSubline('');
      setStatus(SUPPORT_MESSAGE);
    }
  }

  async function updateRowForColor(row, nextColor) {
    const handle = toText(row?.getAttribute('data-handle'));
    if (!handle) return;

    const product = await fetchProductJsonByHandle(handle);
    const pageData = await fetchProductPageDataByHandle(handle).catch(() => ({
      rating: null,
      ratingCount: null,
      swatches: [],
    }));

    const currentItem = {
      handle,
      color: toText(nextColor),
      savedColor: toText(row.getAttribute('data-saved-color') || row.getAttribute('data-color')),
      productId: toId(row.getAttribute('data-product-id')),
      variantId: toId(row.getAttribute('data-variant-id')),
      wishlistVariantId: toId(row.getAttribute('data-wishlist-variant-id') || row.getAttribute('data-variant-id')),
      productUrl: row.querySelector('.oat-wl-img')?.getAttribute('href') || `/products/${handle}`,
    };

    const sizeInfo = buildSizeChoicesFromProduct(product, currentItem.color);
    const variant = getVariantForItem(product, { variantId: '' }, currentItem.color);
    const nextItem = {
      ...currentItem,
      variantId: toId(variant?.id || currentItem.variantId),
      imageSrc: getVariantImageSrc(variant, product),
      title: toText(product?.title) || 'Wishlist item',
      price: formatMoney(variant?.price ?? product?.price, variant?.currency || product?.currency || 'INR'),
      rating: Number.isFinite(Number(pageData?.rating)) ? Number(pageData.rating).toFixed(1) : '',
      swatches: buildColorSwatches(product, currentItem.color, pageData),
      sizeInfo,
    };

    row.outerHTML = buildRowMarkup(nextItem, {
      bowlIcon: getBowlIcon(),
      deleteIcon: getDeleteIcon(),
    });
  }

  async function closeParentSurface(trigger) {
    const popover = trigger.closest('[popover]');
    if (popover && typeof popover.hidePopover === 'function') {
      try {
        popover.hidePopover();
      } catch (_) {}
    }

    const dialogComponent = trigger.closest('dialog-component');
    if (dialogComponent && typeof dialogComponent.closeDialog === 'function') {
      try {
        await dialogComponent.closeDialog();
      } catch (_) {}
      return;
    }

    const dialog = trigger.closest('dialog');
    if (dialog && dialog.open) {
      dialog.close();
    }
  }

  function showDrawer() {
    const refs = getRefs();
    if (!refs || refs.drawer.open) return;

    lockBody();
    refs.drawer.showModal();
  }

  async function closeDrawer() {
    const refs = getRefs();
    if (!refs || !refs.drawer.open) return;

    refs.drawer.classList.add('dialog-closing');
    await waitForAnimationEnd(refs.drawer, 260);
    refs.drawer.close();
    refs.drawer.classList.remove('dialog-closing');
    unlockBody();
  }

  async function handleTriggerClick(trigger) {
    if (!isLoggedIn()) {
      if (typeof window.OatmealAuthPromptOpen === 'function') {
        window.OatmealAuthPromptOpen();
      }
      return;
    }

    await closeParentSurface(trigger);
    showDrawer();
    loadWishlist();
  }

  async function handleWishlistAdd(button) {
    const row = button.closest('.oat-wl-item');
    const select = row ? row.querySelector('[data-oat-wl-size]') : null;
    const chosenVariantId = toId(button.dataset.chosenVariantId || select?.value);

    if (!chosenVariantId) return;

    const handle = toText(button.getAttribute('data-handle'));
    const color = toText(button.getAttribute('data-saved-color') || button.getAttribute('data-color'));
    const productId = toId(button.getAttribute('data-product-id'));
    const variantId = toId(button.getAttribute('data-wishlist-variant-id') || button.getAttribute('data-variant-id'));
    const store = getStore();

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const performAdd = async () => {
        await addVariantToCart(chosenVariantId, 1);

        const count = await fetchCartCount();
        syncHeaderCartCount(count);

        if (store) {
          store.remove({
            handle,
            color,
            productId,
            variantId,
          });
        }

        showToast('Ingredient now added to your bowl, yum!!');
      };

      const wrapped = window.OatLoader?.wrap
        ? window.OatLoader.wrap(performAdd, { delay: 150 })
        : null;

      await (wrapped || performAdd());
    } catch (error) {
      showToast(normalizeAvailabilityMessage(error?.message || 'Could not add to bowl'));
      button.disabled = false;
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  function handleWishlistRemove(button) {
    const store = getStore();
    if (!store) return;

    store.remove({
      handle: toText(button.getAttribute('data-handle')),
      color: toText(button.getAttribute('data-saved-color') || button.getAttribute('data-color')),
      productId: toId(button.getAttribute('data-product-id')),
      variantId: toId(button.getAttribute('data-wishlist-variant-id') || button.getAttribute('data-variant-id')),
    });
  }

  function handleSizeChange(select) {
    const row = select.closest('.oat-wl-item');
    if (!row) return;

    const addButton = row.querySelector('[data-oat-wl-add]');
    if (!addButton) return;

    const chosenVariantId = toId(select.value);
    if (chosenVariantId) {
      addButton.dataset.chosenVariantId = chosenVariantId;
      addButton.disabled = false;
      return;
    }

    delete addButton.dataset.chosenVariantId;
    addButton.disabled = true;
  }

  document.addEventListener('click', async (event) => {
    const eventTarget = event.target instanceof Element ? event.target : null;
    if (!eventTarget) return;

    const trigger = eventTarget.closest('[data-account-wishlist-trigger]');
    if (trigger) {
      event.preventDefault();
      await handleTriggerClick(trigger);
      return;
    }

    const addButton = eventTarget.closest('[data-oat-wl-add]');
    if (addButton) {
      event.preventDefault();
      event.stopPropagation();
      await handleWishlistAdd(addButton);
      return;
    }

    const swatchButton = eventTarget.closest('[data-oat-wl-swatch]');
    if (swatchButton) {
      event.preventDefault();
      event.stopPropagation();
      const row = swatchButton.closest('.oat-wl-item');
      const nextColor = swatchButton.getAttribute('data-color');
      if (row && nextColor) {
        await updateRowForColor(row, nextColor);
      }
      return;
    }

    const removeButton = eventTarget.closest('[data-oat-wl-remove]');
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      handleWishlistRemove(removeButton);
      return;
    }

    const refs = getRefs();
    if (!refs) return;

    if (eventTarget.closest('[data-oat-account-wishlist-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (eventTarget === refs.drawer) {
      closeDrawer();
    }
  });

  document.addEventListener('change', (event) => {
    const eventTarget = event.target instanceof Element ? event.target : null;
    if (!eventTarget) return;

    const select = eventTarget.closest('[data-oat-wl-size]');
    if (!select) return;

    handleSizeChange(select);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const refs = getRefs();
    if (!refs || !refs.drawer.open) return;

    event.preventDefault();
    closeDrawer();
  });

  const drawer = getDrawer();
  if (drawer) {
    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDrawer();
    });
  }

  window.addEventListener('oatmeal:wishlist:changed', () => {
    const refs = getRefs();
    if (!refs || !refs.drawer.open) return;
    loadWishlist();
  });
})();
